import { Dictionary } from "./Dictionary";
var slots_config = {};

slots_config.GameId = {
    FS: 100,        //福神
    FFF: 101,       //发发发
    JZSG: 102,      //决战三国
    DGLFR: 103,     //德古拉夫人
    AJBZ: 104,      //埃及宝藏
    DHLW: 300,      //东海龙王
    LHZB: 301,      //龙虎争霸
    ZEUS: 302,      //雷霆宙斯
    SHLZY: 303,     //撒哈拉之夜
    ZDDCF: 304,     //泽达的财富
    WLZB: 305,      //五龙争霸
    SSXXG: 5000,    //神圣吸血鬼
    QH: 5001,       //拳皇
    MJHL: 5002,     //麻将胡了
    SuperAce: 5003, //超级王牌
    GoldenBook: 5005, //黄金之书
    MJHL2: 5014,     //麻将胡了
};

slots_config.SlotItemId1 = {
    "1": "1,9",
    "2": "2,9",
    "3": "3,9",
    "4": "4,9",
    "5": "5,9",
    "6": "6,9",
    "7": "7,9",
    "8": "8,9",
    "9": "9",
    "10": "10",
};

slots_config.SlotItemId2 = {
    "1": "1,10",
    "2": "2,10",
    "3": "3,10",
    "4": "4,10",
    "5": "5,10",
    "6": "6,10",
    "7": "7,10",
    "8": "8,10",
    "9": "9,10",
    "10": "10",
    "11": "11",
};

slots_config.SlotItemId3 = {
    "T": "T,W",
    "J": "J,W",
    "Q": "Q,W",
    "K": "K,W",
    "A": "A,W",
    "B": "B,W",
    "C": "C,W",
    "D": "D,W",
    "E": "E,W",
    "F": "F,W",
    "W": "W",
};

slots_config.SlotItemId4 = {
    "A": "A,W",
    "B": "B,W",
    "C": "C,W",
    "D": "D,W",
    "E": "E,W",
    "F": "F,W",
    "G": "G,W",
    "H": "H,W",
    "I": "I,W",
    "W": "W",
};

slots_config.SlotItemId5 = {
    "A": "A,A1,W",
    "B": "B,B1,W",
    "C": "C,C1,W",
    "D": "D,D1,W",
    "E": "E,E1,W",
    "F": "F,F1,W",
    "G": "G,G1,W",
    "H": "H,H1,W",
    "A1": "A,A1,W",
    "B1": "B,B1,W",
    "C1": "C,C1,W",
    "D1": "D,D1,W",
    "E1": "E,E1,W",
    "F1": "F,F1,W",
    "G1": "G,G1,W",
    "H1": "H,H1,W",
    "W": "W",
};

slots_config.SlotItemId6 = {
    "A": "A,A1,W,WW",
    "C": "C,C1,W,WW",
    "D": "D,D1,W,WW",
    "P": "P,P1,W,WW",
    "R": "R,R1,W,WW",
    "J": "J,J1,W,WW",
    "Q": "Q,Q1,W,WW",
    "K": "K,K1,W,WW",
    "W": "W,WW",
    "WW": "W,WW",
};

slots_config.SlotItemId7 = {
    "A": "A,W",
    "J": "J,W",
    "Q": "Q,W",
    "K": "K,W",
    "P1": "P1,W",
    "P2": "P2,W",
    "P3": "P3,W",
    "P4": "P4,W",
    "T": "T,W",
    "W": "W",
};

slots_config.SlotItemId8 = {
    "A": "A,wild,wild1,wild2,wild3,wild4,wild5",
    "J": "J,wild,wild1,wild2,wild3,wild4,wild5",
    "Q": "J,wild,wild1,wild2,wild3,wild4,wild5",
    "K": "K,wild,wild1,wild2,wild3,wild4,wild5",
    "P1": "P1,wild,wild1,wild2,wild3,wild4,wild5",
    "P2": "P2,wild,wild1,wild2,wild3,wild4,wild5",
    "P3": "P3,wild,wild1,wild2,wild3,wild4,wild5",
    "P4": "P4,wild,wild1,wild2,wild3,wild4,wild5",
    "lot": "lot,wild,wild1,wild2,wild3,wild4,wild5",
    "nine": "nine,wild,wild1,wild2,wild3,wild4,wild5",
    "ten": "ten,wild,wild1,wild2,wild3,wild4,wild5",
    "scat": "scat",
    "wild": "wild,wild1,wild2,wild3,wild4,wild5",
    "wild1": "wild,wild1,wild2,wild3,wild4,wild5",
    "wild2": "wild,wild1,wild2,wild3,wild4,wild5",
    "wild3": "wild,wild1,wild2,wild3,wild4,wild5",
    "wild4": "wild,wild1,wild2,wild3,wild4,wild5",
    "wild5": "wild,wild1,wild2,wild3,wild4,wild5",
};

slots_config.SlotItemId9 = {
    "A": "A,A1,W",
    "B": "B,B1,W",
    "C": "C,C1,W",
    "D": "D,D1,W",
    "E": "E,E1,W",
    "F": "F,F1,W",
    "G": "G,G1,W",
    "H": "H,H1,W",
    "I": "I,I1,W",
    "A1": "A,A1,W",
    "B1": "B,B1,W",
    "C1": "C,C1,W",
    "D1": "D,D1,W",
    "E1": "E,E1,W",
    "F1": "F,F1,W",
    "G1": "G,G1,W",
    "H1": "H,H1,W",
    "I1": "I,I1,W",
    "W": "W",
};

var slots_dict = slots_config.game_config = new Dictionary();
slots_dict.setObject(slots_config.GameId.FS, slots_config.SlotItemId1);
slots_dict.setObject(slots_config.GameId.FFF, slots_config.SlotItemId1);
slots_dict.setObject(slots_config.GameId.JZSG, slots_config.SlotItemId1);
slots_dict.setObject(slots_config.GameId.DGLFR, slots_config.SlotItemId2);
slots_dict.setObject(slots_config.GameId.AJBZ, slots_config.SlotItemId2);
slots_dict.setObject(slots_config.GameId.DHLW, slots_config.SlotItemId1);
slots_dict.setObject(slots_config.GameId.LHZB, slots_config.SlotItemId2);
slots_dict.setObject(slots_config.GameId.ZEUS, slots_config.SlotItemId1);
slots_dict.setObject(slots_config.GameId.SHLZY, slots_config.SlotItemId2);
slots_dict.setObject(slots_config.GameId.ZDDCF, slots_config.SlotItemId2);
slots_dict.setObject(slots_config.GameId.SSXXG, slots_config.SlotItemId3);
slots_dict.setObject(slots_config.GameId.QH, slots_config.SlotItemId4);
slots_dict.setObject(slots_config.GameId.MJHL, slots_config.SlotItemId5);
slots_dict.setObject(slots_config.GameId.MJHL2, slots_config.SlotItemId9);
slots_dict.setObject(slots_config.GameId.SuperAce, slots_config.SlotItemId6);
slots_dict.setObject(slots_config.GameId.GoldenBook, slots_config.SlotItemId7);
slots_dict.setObject(slots_config.GameId.WLZB, slots_config.SlotItemId8);

export { slots_config }



//////////////////
// WEBPACK FOOTER
// ./untils/slots_config.js
// module id = null
// module chunks = 